import { Chip } from '@heroui/react'

import type { StepStatusType } from './utils'
import { StepStatus } from './utils'

export function StepChip({ status }: { status: StepStatusType }) {
	if (status === StepStatus.COMPLETE) {
		return (
			<Chip
				size="sm"
				variant="flat"
				color="success"
				className="text-tiny relative box-border inline-flex h-6 max-w-fit min-w-min items-center justify-between rounded-full border-none bg-[var(--leangap-green)] px-1 font-semibold whitespace-nowrap text-black"
			>
				<span className="text-black">Complete</span>
			</Chip>
		)
	}
	if (status === StepStatus.ACTIVE) {
		return (
			<Chip
				size="sm"
				variant="flat"
				color="warning"
				className="border-default-300 text-warning-500 text-tiny lg:text-small relative box-border inline-flex h-6 max-w-fit min-w-min items-center justify-between rounded-full border bg-transparent px-2 font-semibold whitespace-nowrap"
			>
				<span className="bg-warning-500 mr-2 inline-block h-2 w-2 rounded-full align-middle"></span>
				<span className="text-warning-500">In progress</span>
			</Chip>
		)
	}
	return (
		<Chip
			size="sm"
			variant="flat"
			color="default"
			className="border-default-300 text-tiny lg:text-small relative box-border inline-flex h-6 max-w-fit min-w-min items-center justify-between rounded-full border px-2 font-semibold whitespace-nowrap text-white"
		>
			Incomplete
		</Chip>
	)
}
